module.exports = __webpack_public_path__ + "img/calendar1.630176d1.png";